import React, { useEffect } from 'react';

import Timer from 'UtilityComponents/Timer';

export const redirectAction = (url) => {
    if (url) {
        window.location = url;
    } else {
        window.location.reload();
    }  
}

const TimerFooter = ({
    redirectTime=5,
    redirectionUrl
}) => {
    useEffect(() => {
        let timer
        if (redirectTime) {
            timer = setTimeout(() => {
                redirectAction(redirectionUrl) 
            }, redirectTime * 1000);
        }
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        }
    }, [redirectTime])

    return (
        <p>Auto redirecting to home page in  <span className="latoBold"><Timer startTime={redirectTime}/></span>.</p>
    )
}

export default TimerFooter;
